/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

'use strict';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var URI = function () {
  function URI(uri) {
    _classCallCheck(this, URI);
    this._uri = uri;
  }
  URI.prototype.toString = function toString() {
    return this._uri;
  };
  return URI;
}();
module.exports = URI;